<template>
    <div class="container-fluid">
        <div class="page-title">
            <h4>Ajouter un utilisateur</h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-block">
                        <div class="col-md-10 ml-auto mr-auto">

                            <div class="row" v-show="NoRole">
                                <div class="col-md-12 text-center alert alert-warning">
                                   Pour ajouter un utilisateur merci d’indiquer au moins un rôle ( Adhérent(e) ou/et Responsable )
                                </div>
                            </div>
                            <b-overlay v-if="stateForm==0" :show="isBusy" rounded="sm" opacity="0.50 " variant="white" >
                            <form @submit.prevent="CheckEmail" v-if="stateForm==0">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Adresse email<span class="text-danger">*</span></label>
                                            <input v-model="email" type="email" placeholder="Entrer son email" class="form-control"  pattern="[^@\s]+@[^@\s]+\.[^@\s]+"  size="30" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right mrg-top-5">
                                    <button type="button" class="btn btn-default button-previous mr-4" @click="cancel()">Annuler</button>
                                    <button type="submit" class="btn btn-primary" :disabled="NoRole">Suivant</button>                                                                                       
                                </div>

                            </form>
                            </b-overlay>
                            <form @submit.prevent="add" v-show="stateForm==1">
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label>Intitulé<span class="text-danger">*</span></label>
                                            <select v-model="title" class="form-control custom-select" required>
                                                <option disabled value="">Choisir...</option>
                                                <option>Mme.</option>
                                                <option>M.</option>
                                                <option>CUMA</option>
                                                <option>EARL</option>
                                                <option>SCEA</option>
                                                <option>GAEC</option>
                                                <option>SAS</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Nom<span class="text-danger">*</span></label>
                                            <input v-model="lastname" 
                                                    type="text" 
                                                    name="Nom" 
                                                    @keypress="check_input($event)"
                                                    placeholder="Entrer le nom de famille" 
                                                    class="form-control" 
                                                    minlength="1" 
                                                    maxlength="255"
                                                    required>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Prénom<span v-show='required.firstname' class="text-danger" >*</span></label>
                                            <input  v-model="firstname" 
                                                    type="text" 
                                                    name="Prénom" 
                                                    @keypress="check_input($event)"
                                                    placeholder="Entrer le prénom" 
                                                    class="form-control" 
                                                    minlength="1" 
                                                    maxlength="255"
                                                    :required='required.firstname'>
                                        </div>
                                    </div>                                   
                                </div>
<!-- ########################################################## -->
<!--                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label>Intitulé<span class="text-danger">*</span></label>
                                            <select v-model="title" class="form-control custom-select" required>
                                                <option disabled value=null>Choisir...</option>
                                                <option>Mme.</option>
                                                <option>M.</option>
                                                <option>CUMA</option>
                                                <option>EARL</option>
                                                <option>SCEA</option>
                                                <option>GAEC</option>
                                                <option>SAS</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div :class="required.firstname? 'col-md-5' : 'col-md-10' ">
                                        <div class="form-group">
                                            <label>Nom<span class="text-danger">*</span></label>
                                            <input v-model="lastname" 
                                                    type="text" 
                                                    name="Nom" 
                                                    @keypress="check_input($event)"
                                                    placeholder="Entrer le nom de famille" 
                                                    class="form-control" 
                                                    minlength="1" 
                                                    maxlength="255"
                                                    required>
                                        </div>
                                    </div>
                                    <div class="col-md-5" v-show="required.firstname">
                                        <div class="form-group">
                                            <label>Prénom<span v-show='required.firstname' class="text-danger" >*</span></label>
                                            <input  v-model="firstname" 
                                                    type="text" 
                                                    name="Prénom" 
                                                    @keypress="check_input($event)"
                                                    placeholder="Entrer le prénom" 
                                                    class="form-control" 
                                                    minlength="1" 
                                                    maxlength="255"
                                                    :required='required.firstname'>
                                        </div>
                                    </div>                                   
                                </div>
                                -->
<!-- ########################################################## -->
                                <div class="row">
                                   <div class="col-md-3 m-auto">
                                        <div class="form-group align-middle">
                                            <label class="mr-2 ml-2">Responsable</label> <br>
                                            <input class="align-middle mr-2 ml-2" type="radio" id="one" :value="true" v-model="role.res"> <span :for="true" class="align-middle mr-2"> Oui </span>
                                            <input class="align-middle mr-2 ml-2" type="radio" id="two" :value="false" v-model="role.res"> <span :for="false" class=align-middle> Non </span>
                                        </div>
                                   </div>

                                   <div class="col-md-3 m-auto">
                                        <div class="form-group align-middle ">
                                            <label class="mr-2 ml-2">Adhérent(e)</label> <br>
                                            <input class="align-middle mr-2 ml-2" type="radio" id="one" :value="true" v-model="role.adh"> <span :for="true" class="align-middle mr-2"> Oui </span>
                                            <input class="align-middle mr-2 ml-2" type="radio" id="two" :value="false" v-model="role.adh"> <span :for="false" class=align-middle> Non </span>
                                        </div>
                                   </div>

                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Code adhérent<span v-show="role.adh" class="text-danger">*</span></label>
                                            <input v-model="code"
                                                    type="text" 
                                                    name="Code adhérent"
                                                    @keypress="check_input($event)"
                                                    placeholder= "Entrer le code adhérent"
                                                    class="form-control" 
                                                    minlength="1" 
                                                    maxlength="255"
                                                    :required="role.adh"
                                                    :disabled="!role.adh" >
                                        </div>
                                    </div>

                                </div>

<!-- ########################################################## -->
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Adresse email<span class="text-danger">*</span></label>
                                            <input v-model="email" type="email" placeholder="Entrer son email" class="form-control"  pattern="[^@\s]+@[^@\s]+\.[^@\s]+"  size="30" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                   <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Télephone fixe<span v-show="required.tel ? 'text-danger' : ''"  class="text-danger">*</span></label>
                                            <input  v-model="tel" 
                                                    type="tel" 
                                                    name="Télephone fixe" 
                                                    @keypress="check_phone_number($event)"
                                                    placeholder="Entrer son numéro fixe" 
                                                    class="form-control"
                                                    minlength="1" 
                                                    maxlength="255"
                                                    :required="required.tel">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                                <label>Télephone mobile<span v-show="required.mobile" class="text-danger">*</span></label>
                                            <input  v-model="mobile"
                                                    type="tel" 
                                                    name="Télephone mobile"
                                                    @keypress="check_phone_number($event)"
                                                    placeholder="Entrer son numéro mobile" 
                                                    class="form-control"
                                                    minlength="1" 
                                                    maxlength="255"
                                                    :required="required.mobile">
                                        </div>
                                    </div>
                                </div>  
                                
                                                                  
                                <div class="text-right mrg-top-5">
                                    <button type="button" class="btn btn-default button-previous mr-4" @click="cancel()">Annuler</button>
                                    <button type="submit" class="btn btn-primary" :disabled="NoRole">Créer</button>                                                                                       
                                </div>
                                
                                <div class="alert alert-danger" role="alert" v-if="error">
                                    <span v-if="userExist">
                                        Un utilisateur avec cette adresse e-mail existe déjà !!!!
                                    </span>
                                    <br>
                                        Impossible d'ajouter d'utilisateur ! Veuillez contacter KEMTAG
                                    <i class="ti-close float-right mt-1" @click="error = false , userExist=false"></i>
                                </div>                                  
                            </form>                                                                                                           
                       </div>
                    </div>
                </div>
            </div>
        </div>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  

        <b-modal  ref="user_exist" centered hide-footer size="xl" no-close-on-backdrop >     

            <template #modal-header="{}">
                <div class="text-center mt-3 m-auto"> 
                    <div v-if="!userExist_Add">
                        <div class="mt-3 align-middle"  style="line-height: 3em;">
                           <span style="font-size: 15px">
                               Cette adresse mail "<b> {{selected_user.email}} </b>" existe déjà. <br>
                                <span v-if="ExistInStruture">
                                    <span v-if="ExistInStruture_Status==0">
                                        <b> {{selected_user.lastname}} {{selected_user.firstname}} </b> appartient à votre structure.
                                        <br> Voulez-vous modifier ses rôles et permissions ?
                                    </span>
                                    <span v-else>
                                        <b> {{selected_user.lastname}} {{selected_user.firstname}} </b>  n'a pas encore accpeter ou réfuser votre invitation.
                                        <br> Voulez-vous modifier ses rôles et permissions ?
                                    </span>
                                   
                                </span>
                                <span v-else >
                                    Voulez-vous l'ajouter à votre structure ?
                                </span>

                           </span>
                            
                             
                        </div>
                        <div class="mt-4 mb-0">
                            <b-button class="btn btn-default mr-3"  @click="$refs.user_exist.hide()" :disabled="isBusy" style="font-size: 15px;">Annuler</b-button>
                            <b-button @click="[userExist_Add=true,AnnulerRole= (ExistInStruture_Status==0 )? false : true ]" class="btn btn-primary" style="font-size: 15px;"> Suivant </b-button>
                        </div >
                    </div>
                    
                    <div v-else> 
                        <span style="font-size: 15px" v-if="!ExistInStruture"> 
                            Pour pouvoir ajouter cet utilisateur à votre structure merci de lui donner au moins un rôle.
                        </span>
                    </div>
                </div>
            </template>
            <template #default="{}" >
                <div v-if="userExist_Add">
                    <v-user-permission v-show="!AnnulerRole" :selected_user="selected_user" :action="action" @user-permission-done = "close_permission_modal"> </v-user-permission>
                    
                    <v-annuler-role v-show="AnnulerRole" 
                    :selected_user="selected_user" 
                    action="Annuler" 
                    @close= "close_annuler_role" 
                    @AnnulerRole= "cancel"
                    :structure_id="$store.getters.structure_id" ></v-annuler-role>

                </div>
            </template>

        </b-modal>
   
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  
    </div>
</template>

<script>

    import api from "../../config/_api";
    import { mapGetters } from 'vuex';
    import UserPermission from "../../components/UserPermission.vue";
    
    import AnnulerRole from "../../components/Role/AnnulerRole.vue";
    
    export default {
        name: "Add",
        components:{
            'v-user-permission': UserPermission,
            'v-annuler-role': AnnulerRole,
        },
        data () {
            return {
                ExistInStruture : false,
                AnnulerRole : false , 
                ExistInStruture_Status : 0,
                action : "add",
                isBusy : false ,
                stateForm :0 ,
                userExist : false,
                userExist_Add: false,
                selected_user: null,
                code: "",
                title: "",
                firstname: "",
                lastname: "",
                email: "",
                tel: "",
                mobile: "",
                role : {
                    adh : true,
                    res: false
                },
                error: false,
                required : {
                    mobile : true, 
                    tel :true,
                    firstname : true
                },
                SetPermission : null,
                errormsg:"",
            }
        },
        computed:{
            NoRole(){
                 if(this.role.adh==false&&this.role.res==false){
                    return true;
                }
                else{
                    return false;
                }
            },
            ...mapGetters({
                structure: 'structure/structure',
            }),
               
        },
        mounted() {
            this.$store.dispatch('structure/getStructure');
        },
        watch :{
            email(){
                this.email=this.email.toString().replace(' ','');
            },
            tel(){  
                    var tel=this.tel.toString().replace(/\s|\.|,|-|_/g,'');
                    var mobile = this.mobile.toString().replace(/\s|\.|,|-|_/g,'');
                    this.required.tel=((tel.length>=10)||((mobile.length<10)&&(tel.length<10)));
                    this.required.mobile=((mobile.length>=10)||((mobile.length<10)&&(tel.length<10)));
                    /*
                    this.tel=this.tel.toString().replace(/\s|\.|,|-|_/g,'');
                    this.mobile=this.mobile.toString().replace(/\s|\.|,|-|_/g,'');
                    this.required.tel=((this.tel.length>=10)||((this.mobile.length<10)&&(this.tel.length<10)));
                    this.required.mobile=((this.mobile.length>=10)||((this.mobile.length<10)&&(this.tel.length<10)));
                   */
            },
            mobile(){
                    var tel=this.tel.toString().replace(/\s|\.|,|-|_/g,'');
                    var mobile = this.mobile.toString().replace(/\s|\.|,|-|_/g,'');
                    this.required.mobile=((mobile.length>=10)||((mobile.length<10)&&(tel.length<10)));
                    this.required.tel=((tel.length>=10)||((mobile.length<10)&&(tel.length<10)));
                    /*
                    this.mobile=this.mobile.toString().replace(/\s|\.|,|-|_/g,'');
                    this.tel=this.tel.toString().replace(/\s|\.|,|-|_/g,'');
                    this.required.mobile=((this.mobile.length>=10)||((this.mobile.length<10)&&(this.tel.length<10)));
                    this.required.tel=((this.tel.length>=10)||((this.mobile.length<10)&&(this.tel.length<10)));
                     */
            },
            title(){
                    this.required.firstname=(this.title=='M.' || this.title=='Mme.'  || this.title===null || this.title=="");
            },
        },
        methods: {
                CheckEmail(){
                    this.isBusy=true;
                    this.axios({url: api.url + 'adherents/checkEmail', data: {email : this.email,structure_id : this.$store.getters.structure_id}, method: 'POST' })
                            .then(resp => { 
                                 if(resp.data.exist){
                                     this.clear();
                                    this.userExist=true;
                                    this.ExistInStruture=resp.data.structure;
                                    this.ExistInStruture_Status=resp.data.status;
                                    this.selected_user=resp.data.user;
                                    this.isBusy=false;
                                    this.stateForm=0;

                                    if(this.ExistInStruture){
                                        this.action='edit';
                                    }
                                    this.$refs.user_exist.show();
                                }
                                else {
                                    this.userExist=false;  
                                    this.isBusy=false;  
                                    this.stateForm =1;  
                                }
                                 return  this.userExist ;   
                            })
                            .catch(err => {                              
                            });
                },
            cancel() {
               this.clear();
               this.$router.push("/adherents/index");
            },
            clear(){
               this.code = "";
               this.title = "";
               this.firstname= "";
               this.lastname= "";
               this.email= "";
               this.tel= "";
               this.mobile="";
            },
            add() {
                let data = {
                    link : api.link ,
                    code: this.code,
                    title: this.title,
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: this.email,
                    tel: this.tel,
                    mobile: this.mobile,
                    role_adh: this.role.adh,
                    role_res : this.role.res
                };
                // vérifier la date de fin d'abonnement
                let date= new Date();
                //console.log(date);
                let nowDate = Date.parse(date); // date actuel en timestamp  
                if(!this.CheckEmail()){

                            //console.log(resp.data[0].contract_ending_date);
                            //console.log(resp.data[0]);
                    let endingDate = Date.parse(this.$store.getters['structure/structure'][0].contract_ending_date); // date de fin d'abonnement en timestamp                        
                    if ( endingDate >= nowDate && nowDate != null)  
                    {
                        this.axios({url: api.url + 'adherents?structure_id=' + this.$store.getters.structure_id, data: data, method: 'POST' })
                        .then(resp => { 
                            this.$router.push("/adherents/index");
                        })
                        .catch(err => {     
                            this.error = true;                               
                        });

                    }
                    else {                            
                        this.error = true;                                                                       
                    }    
                }
            },
            check_phone_number: function(event){
                if(event.keyCode < 8 || event.keyCode > 57 || event.keyCode ==13 || event.keyCode ==33 || event.keyCode ==34|| event.keyCode ==35 || event.keyCode ==36 || event.keyCode ==37 || event.keyCode ==38 || event.keyCode ==39 || event.keyCode ==40 || event.keyCode ==41 || event.keyCode ==42 || event.keyCode ==44 || event.keyCode ==45 || event.keyCode ==46 || event.keyCode ==47) event.returnValue = false;
                if( event.which < 8 || event.which > 57 || event.which ==13 || event.which ==33 || event.which ==34 || event.which ==35 || event.which ==36 || event.which ==37 || event.which ==38 || event.which ==39 || event.which ==40 || event.which ==41 || event.which ==42 || event.which ==44 || event.which ==45 || event.which ==46 || event.which ==47) return false;
            },
            check_input: function(event){
                if( event.keyCode < 8 ||  event.keyCode > 122 || event.keyCode==13 || event.keyCode==33 || event.keyCode==34 || event.keyCode==35 || event.keyCode==36 || event.keyCode==37 || event.keyCode==38 || event.keyCode==39 || event.keyCode==40 || event.keyCode==41 || event.keyCode==42 || event.keyCode==43 || event.keyCode==44 || event.keyCode==46 || event.keyCode==47 || event.keyCode==58 || event.keyCode==59 || event.keyCode==60 || event.keyCode==61 || event.keyCode==62 || event.keyCode==63 || event.keyCode==64 || event.keyCode==91 || event.keyCode==92 || event.keyCode==93 || event.keyCode==94 || event.keyCode==96) event.returnValue = false;
                if( event.which < 8 ||  event.which > 122  || event.which==13 || event.which==33 || event.which==34 || event.which==35 || event.which==36 || event.which==37 || event.which==38 || event.which==39 || event.which==40 || event.which==41 || event.which==42 || event.which==43 || event.which==44|| event.which==46 ||  event.which==47 ||  event.which==58 ||  event.which==59 ||  event.which==60 ||  event.which==61 ||  event.which==62 ||  event.which==63 ||  event.which==64 ||  event.which==91 ||  event.which==92 ||  event.which==93 ||  event.which==94 ||  event.which==96) return false;
            },
            open_permission_modal(user) {
                this.selected_user=user;
                this.$refs.permission_popup.show();
            },
            close_permission_modal(data){
                if(data){
                    this.SetPermission=data.error;

                    if(data.error){
                        this.errormsg=data.errormsg;
                    }
                    this.userExist_Add=true;
                }
                else {
                    this.userExist_Add=false;
                }
                    this.$refs.user_exist.hide();
                    this.cancel();
            },
            
            close_annuler_role(){
                this.selected_user=null;
                this.$refs.user_exist.hide();
                this.userExist_Add=false;
                this.clear();
            },

        }
        
    }
</script>

<style scoped>

</style>